import React from "react";

const ImagesPage: React.FC = () => <p>Under construction</p>;

export default ImagesPage;
